export default "__VITE_ASSET__DoNxkfOZ__"